<template>
  <div class="p-drawer reservation-sidebar">
    <!-- アイコン部 -->
    <div class="p-drawer__icons">
      <a
        :class="{ 'p-drawer__icons__expand': true, 'is-disable': isSidebarWidthMax }"
        @click="expand"
      >
        <v-icon
          icon="mdi-play-circle"
          size="large"
        />
      </a>
      <a
        :class="{ 'p-drawer__icons__shrink': true, 'is-disable': isSidebarWidthMin }"
        @click="shrink"
      >
        <v-icon
          icon="mdi-play-circle"
          size="large"
        />
      </a>
    </div>

    <!-- サイドバー本体部 -->
    <v-navigation-drawer
      class="p-drawer__main"
      :width="sidebarWidth"
      location="right"
      permanent
    >
      <!-- 最小化時の表示 -->
      <a
        v-if="isSidebarWidthMin"
        class="p-drawer__minimized"
        @click="expand"
      >
        <v-icon class="p-drawer__minimized-icon">
          mdi-book-open-page-variant
        </v-icon>
        <span class="p-drawer__minimized-text">
          ジャーナル検索
        </span>
      </a>
      <div v-show="!isSidebarWidthMin">
        <div
          class="p-drawer__header d-flex align-center px-3"
        >
          <v-icon class="mr-1">
            mdi-book-open-page-variant
          </v-icon>
          <span class="font-weight-bold">ジャーナル検索</span>
        </div>
        <journal-tab 
          ref="journalTabRef"
          class="p-drawer__journal-tab"
          type="reservation"
        /> <!-- タブ「ジャーナル検索」 -->
      </div>
    </v-navigation-drawer>
  </div>
</template>

<script setup>
import { computed, ref, watch, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

// ジャーナル検索
import JournalTab from "./Journal/journalTab.vue";

const store = useStore();
const route = useRoute();

// JournalTabコンポーネントの参照
const journalTabRef = ref(null);

// const sidebarTabId = computed(() => store.getters.sidebarTabId);
const sidebarWidthRank = computed(() => store.getters.sidebarWidthRank);
const sidebarWidth = computed(() => store.getters.sidebarWidth);
const isSidebarWidthMin = computed(() => store.getters.isSidebarWidthMin);
const isSidebarWidthMax = computed(() => store.getters.isSidebarWidthMax);
const reservation = computed(() => store.getters.reservation);

const expand = () => {
  if (!isSidebarWidthMax.value) {
    store.dispatch("updateSidebarWidthRank", sidebarWidthRank.value + 1);
  }
};

const shrink = () => {
  if (!isSidebarWidthMin.value) {
    store.dispatch("updateSidebarWidthRank", sidebarWidthRank.value - 1);
  }
};

// --- ▼ ReservationのFetchが完了/失敗したタイミングで、サイドバーの各タブの初期化をトリガーする ---
const initializeTabs = () => {
  store.dispatch("updateSidebarWidthRank", 1); // サイドバーの幅を初期化
  if (!!reservation.value && reservation.value.id == parseInt(route.query.reservation_id)) {
    if (journalTabRef.value) journalTabRef.value.start();
  } else {
    if (journalTabRef.value) journalTabRef.value.clear();
  }
};

// コンポーネントのマウント時と、reservationの変更時にサイドバーの各タブの初期化を実行
onMounted(() => {
  initializeTabs();
});
watch(
  () => reservation.value,
  () => {
    initializeTabs();
  }
);
// --- ▲ ReservationのFetchが完了/失敗したタイミングで、サイドバーの各タブの初期化をトリガーする ---
</script>

<style lang="scss">
html:has(.reservation-sidebar) {
  overflow: hidden !important; /* スクロールバーを非表示にする */
}
</style>

<style lang="scss" scoped>
.p-drawer {
  &__icons {
    position: absolute;
    z-index: 2000;
    /* v-navigation-drawerになぜか動的にz-indexが指定される */
    margin-left: -12px;
    display: flex;
    flex-direction: column;
    margin-top: 50px;

    &__expand {
      transform: rotate(180deg);
      height: 25px;

      &.is-disable {
        opacity: 0;
      }
    }

    &__shrink {
      height: 25px;
      margin-top: 8px;

      &.is-disable {
        opacity: 0;
      }
    }
  }

  &__main {
    border-left: 1px solid #C9C5C5;
    height: calc(100vh - 112px) !important; /* 112pxはヘッダーの高さ */
    overflow: auto;
  }

  &__minimized {
    display: block;
    height: 100%;
    width: 100%;
    text-align: center;
  }

  &__minimized-icon {
    padding-top: 80px;
    font-size: 20px;
    margin-top: 10px;
  }

  &__minimized-text {
    writing-mode: vertical-rl;
    padding-top: 15px;
    letter-spacing: 0.5em;
    font-size: 14px;
    width: 18px;
  }

  &__header {
    height: 40px;
    background-color: #eee;
    border-bottom: 1px solid #ccc;
  }

  &__journal-tab {
    font-size: 14px;
  }

  :deep(.v-navigation-drawer) {
    /* absoluteがつくとflexでうまく配置されない */
    position: initial !important;
  }
}
</style>